"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const ordinal_1 = __importDefault(require("ordinal"));
const core_1 = require("@material-ui/core");
const FileCopy_1 = __importDefault(require("@material-ui/icons/FileCopy"));
const MoreVert_1 = __importDefault(require("@material-ui/icons/MoreVert"));
const WorkflowRepeatIconButton = props => {
    const { index, onAddRepeatClick, onRemoveRepeatClick } = props;
    const [anchorEl, setAnchorEl] = react_1.default.useState(null);
    const handleOpenMenuClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (event) => {
        event.stopPropagation();
        setAnchorEl(null);
    };
    const handleAddClick = (event) => {
        handleClose(event);
        onAddRepeatClick();
    };
    const handleRemoveClick = (event) => {
        handleClose(event);
        onRemoveRepeatClick();
    };
    return index === 0 ? (react_1.default.createElement(core_1.Button, { color: 'primary', startIcon: react_1.default.createElement(FileCopy_1.default, null), onClick: handleAddClick }, "REPEAT")) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Typography, null,
            ordinal_1.default(index),
            " Repeat"),
        react_1.default.createElement(core_1.IconButton, { color: 'primary', onClick: handleOpenMenuClick, size: 'small' },
            react_1.default.createElement(MoreVert_1.default, null)),
        react_1.default.createElement(core_1.Menu, { anchorEl: anchorEl, open: Boolean(anchorEl), onClose: handleClose },
            react_1.default.createElement(core_1.MenuItem, { onClick: handleAddClick }, "Repeat"),
            react_1.default.createElement(core_1.MenuItem, { onClick: handleRemoveClick },
                react_1.default.createElement(core_1.Typography, { color: 'error' }, "Remove Repeat")))));
};
exports.default = WorkflowRepeatIconButton;
//# sourceMappingURL=WorkflowRepeatIconButton.js.map